module.exports = __webpack_public_path__ + "static/media/CLA_CSV_2.27913e8d.svg";